module.exports = __webpack_public_path__ + "img/coacho_tablet.b6e4426b.png";